// jwtHelper.js
import jwt from 'jsonwebtoken'

export function decodeToken(token) {
  return jwt.decode(token)
}

export function getTokenExpirationDate(token) {
  const decoded = jwt.decode(token)
  if (!decoded || !decoded.exp) {
    return null
  }
  const date = new Date(0)
  date.setUTCSeconds(decoded.exp)
  return date
}

export function isTokenExpired(token) {
  const expirationDate = this.getTokenExpirationDate(token)
  return expirationDate ? expirationDate < new Date() : false
}
